// extracted by mini-css-extract-plugin
export default {"formsActions":"ProjectErrorMessagesPage_formsActions__gIt8V","input":"ProjectErrorMessagesPage_input__ObQyF","inputWarningMsg":"ProjectErrorMessagesPage_inputWarningMsg__RLgLZ"};